import type { FormModel } from '@acme/foundation';
import { FormControls } from '@acme/foundation';

export const ApplicationFormFields = <TCtx,>({
  form,
  walletsForm,
  cryptoFieldIds,
  showIncomingWallets,
  onAddWallet,
}: {
  form: FormModel<TCtx>;
  walletsForm: FormModel<Record<string, unknown>>;
  cryptoFieldIds: string[];
  showIncomingWallets: boolean;
  onAddWallet: () => void;
}) => {
  return (
    <div className="mt-6 grid grid-cols-2 gap-6">
      <FormControls
        form={form}
        filter={(cfg) => !cryptoFieldIds.includes(cfg.id)}
      />

      {showIncomingWallets && (
        <>
          <FormControls form={walletsForm} />

          <div
            onClick={onAddWallet}
            className="flex gap-2 items-center text-brand-purple-900 cursor-pointer col-span-2"
          >
            <span className="text-xl leading-none">+</span>
            Добавить адрес криптокошелька
          </div>
        </>
      )}

      <FormControls
        form={form}
        filter={(cfg) => cryptoFieldIds.includes(cfg.id)}
      />
    </div>
  );
};
